export enum ActionExecutionStatus {
  'PENDING' = 'PENDING',
  'PROCESSING' = 'PROCESSING',
  'RETRYING' = 'RETRYING',
  'FAILED' = 'FAILED',
  'SUCCESS' = 'SUCCESS',
}
